var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1778.27 824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efefef;}.cls-2{fill:none;stroke:#efefef;stroke-miterlimit:10;stroke-width:18px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pattern04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6,
    cy: 773,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29,
    cy: 761,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52,
    cy: 748,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18,
    cy: 795,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41,
    cy: 783,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 770,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30,
    cy: 818,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53,
    cy: 806,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76,
    cy: 793,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1219.88,
    cy: 580.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1242.88,
    cy: 568.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1265.88,
    cy: 555.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1231.88,
    cy: 602.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1254.88,
    cy: 590.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1277.88,
    cy: 577.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1243.88,
    cy: 625.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1266.88,
    cy: 613.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1289.88,
    cy: 600.78,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 353.11,
    cy: 268.68,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 378.57,
    cy: 266.53,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 404.4,
    cy: 263.48,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 355.64,
    cy: 293.23,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 381.1,
    cy: 291.08,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 406.93,
    cy: 288.02,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 357.79,
    cy: 318.68,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.25,
    cy: 316.53,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 409.08,
    cy: 313.47,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1025.68,
    cy: 48.19,
    r: 5.96,
    transform: "translate(308.44 837.82) rotate(-56.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 943.23,
    cy: 11.69,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 969.45,
    cy: 11.34,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1025.64,
    cy: 73.07,
    r: 5.96,
    transform: "translate(287.72 848.87) rotate(-56.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 943.18,
    cy: 36.56,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 969.4,
    cy: 36.22,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1025.11,
    cy: 98.82,
    r: 5.96,
    transform: "translate(266.06 859.89) rotate(-56.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 942.65,
    cy: 62.31,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 968.88,
    cy: 61.97,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 966.47,
    cy: 467,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1329.47,
    cy: 400,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 522.78,
    cy: 511.94,
    r: 19.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1681.47,
    cy: 798,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 58,
    cy: 449,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 626.97,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.67,767.59l-42.12-17.34h0a41.56,41.56,0,0,1,42.12,17.35Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M652.31,783.85,587,757.42a40.81,40.81,0,0,1,7.55-4.36h0l55,21.55h0A40.25,40.25,0,0,1,652.31,783.85Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M652.9,791a42,42,0,0,1-.54,6.71h-.05l-75.18-30.12a41.16,41.16,0,0,1,4.8-5.81l70.94,28C652.9,790.21,652.9,790.6,652.9,791Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.1,803.13a42.29,42.29,0,0,1-2.9,7.08L571.66,779a38.67,38.67,0,0,1,2.65-6.66Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.42,814.77a41.64,41.64,0,0,1-5.18,6.07L569.9,792.71V791a42.1,42.1,0,0,1,.41-5.83Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.71,824.63a41.67,41.67,0,0,1-8.42,4.72l-54.16-22.29a41,41,0,0,1-2.5-8.24Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.82,831.84a42,42,0,0,1-7.42.66A41.44,41.44,0,0,1,577.55,815Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1777,350l-30.35,34h0A41.53,41.53,0,0,1,1777,350Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1794.52,349.16l-46.61,52.77a39.87,39.87,0,0,1-1.61-8.57h0l38.58-44.67h0A40.44,40.44,0,0,1,1794.52,349.16Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1801.47,351a40.18,40.18,0,0,1,6.15,2.74l-.07.06-53.38,60.84a42.6,42.6,0,0,1-3.88-6.45l50-57.6Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1812.3,356.68a40,40,0,0,1,5.72,5.08l-54.85,61.83a41,41,0,0,1-5.39-4.72Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1821.4,365.9a42.6,42.6,0,0,1,4,6.9l-49.9,57-1.62-.54a43.13,43.13,0,0,1-5.36-2.32Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1827.48,378.34a41.92,41.92,0,0,1,1.65,9.51l-39,43.67a41.2,41.2,0,0,1-8.6-.38Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1828.65,396.66A41.53,41.53,0,0,1,1799.08,430Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 957.27,
    y: 670.64,
    width: 143.67,
    height: 28.69,
    rx: 14.34,
    ry: 14.34,
    transform: "translate(-275.54 958.8) rotate(-48.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1156.35,
    y: 241.03,
    width: 63.03,
    height: 35.46,
    rx: 17.64,
    ry: 17.64,
    transform: "translate(95.22 934.99) rotate(-48.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1335.24,41.78l15,17.39a6.41,6.41,0,0,1-.65,9h0a6.41,6.41,0,0,1-9-.65l-15-17.4a6.38,6.38,0,0,1,.65-9h0A6.41,6.41,0,0,1,1335.24,41.78Z",
    transform: "translate(-108.12 -37)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 804.34,
    y: 307.28,
    width: 104.38,
    height: 152.03,
    rx: 24.75,
    ry: 24.75,
    transform: "translate(-137.98 654.31) rotate(-43.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M843,296.27l-2.9,78.29a25.19,25.19,0,0,0,24.24,26.1h.17L942.59,403",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 662.23,
    y1: 326.56,
    x2: 732.37,
    y2: 329.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 762.93,
    y1: 433.53,
    x2: 765.03,
    y2: 363.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1720.49,
    y: 644.74,
    width: 152.03,
    height: 104.38,
    rx: 24.75,
    ry: 24.75,
    transform: "translate(-97.41 1383.87) rotate(-43.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1709.48,710.44l78.29,2.9a25.19,25.19,0,0,0,26.1-24.24,1,1,0,0,0,0-.17l2.36-78",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1668.65,
    y1: 746.12,
    x2: 1671.32,
    y2: 675.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1775.62,
    y1: 645.42,
    x2: 1706.02,
    y2: 643.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 285.54,
    y: 103.52,
    width: 152.03,
    height: 104.38,
    rx: 24.75,
    ry: 24.75,
    transform: "translate(-116.56 253.15) rotate(-43.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.54,169.23l78.29,2.9a25.19,25.19,0,0,0,26.1-24.24.91.91,0,0,1,0-.17l2.36-78",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 233.69,
    y1: 204.91,
    x2: 236.37,
    y2: 134.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 340.67,
    y1: 104.21,
    x2: 271.07,
    y2: 102.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.34,645.71q-19.09,19.1-42.5,19.85T208.2,648.08q-18.45-18.44-18.07-42.66t18-41.8Q224.71,547,245.84,546t36.25,14.13q12,12,13.54,26.26t-7.07,23.14a16.87,16.87,0,0,1-8.41,4.86,11.76,11.76,0,0,1-8.31-1.08,21.19,21.19,0,0,1-.75,10.57,22,22,0,0,1-5.4,9,21.32,21.32,0,0,1-16.93,6.58q-9.82-.54-18-8.73-10.45-10.47-11.27-23.9t7.93-22.17a20.39,20.39,0,0,1,8.25-5,12.33,12.33,0,0,1,9,.27l-4-5.72,9.49-9.49,21,32.47c1.15,1.44,1.95,2.37,2.38,2.8q3.78,3.78,7.44.11,4.32-4.32,2-13.43t-10.2-17q-11.64-11.66-27.24-11T217,572.35q-14,14-13.86,32.41T218.23,638q14.13,14.13,32.09,14.19T283.6,637a47.42,47.42,0,0,0,14-27.83L309,611q-.21,8.41-5,18.17A61.43,61.43,0,0,1,292.34,645.71Zm-38.08-51.46q-4.32-4.31-8.85-4.63T237,593.18A14.4,14.4,0,0,0,232.84,606a23.24,23.24,0,0,0,6.95,13.54q10.68,10.68,19,2.37,4.86-4.86,3.61-12.57t-8.14-15Z",
    transform: "translate(-108.12 -37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1589.28,246.31q-19.11-19.09-19.85-42.5t17.48-41.64q18.43-18.45,42.66-18.07t41.8,18Q1688,178.72,1689,199.86t-14.13,36.24q-12,12-26.26,13.54t-23.14-7.06a16.9,16.9,0,0,1-4.86-8.42,11.69,11.69,0,0,1,1.08-8.3,21.31,21.31,0,0,1-10.57-.76,22.12,22.12,0,0,1-9-5.39,21.33,21.33,0,0,1-6.58-16.94q.54-9.81,8.73-18,10.47-10.47,23.9-11.28t22.17,7.93a20.39,20.39,0,0,1,5,8.25,12.33,12.33,0,0,1-.27,9l5.72-4,9.49,9.49-32.47,21c-1.44,1.15-2.37,1.94-2.8,2.37q-3.78,3.78-.11,7.44,4.32,4.32,13.43,2t17-10.19q11.65-11.65,11-27.24T1662.63,171q-14-14-32.41-13.87t-33.28,15.05q-14.13,14.15-14.19,32.1T1598,237.56a47.48,47.48,0,0,0,27.83,14L1624,262.88q-8.41-.21-18.17-5A61.55,61.55,0,0,1,1589.28,246.31Zm51.45-38.08q4.32-4.3,4.64-8.84t-3.56-8.42a14.43,14.43,0,0,0-12.78-4.15,23.19,23.19,0,0,0-13.54,7q-10.68,10.68-2.37,19,4.86,4.86,12.57,3.62t15-8.21Z",
    transform: "translate(-108.12 -37)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern04);
export default __webpack_public_path__ + "static/media/pattern04.99efc283013c2da080b99b2517117a23.svg";
export { ForwardRef as ReactComponent };